import polygonalChartType from '@/domain/enums/polygonalCharts/polygonalChart';
import gasRatioTranslatorBuilder from './gasRatio/builder';
import C2h2C2h4C2h4C2h6 from './gasRatio/C2h2C2h4_C2h4C2h6';
import C2h2C2h4Ch4H2 from './gasRatio/C2h2C2h4_Ch4H2';

export default {
  [polygonalChartType.GASES_RATIO_C2H2_C2H4_CH4_H2]: gasRatioTranslatorBuilder(C2h2C2h4Ch4H2),
  [polygonalChartType.GASES_RATIO_C2H2_C2H4_C2H4_C2H6]: gasRatioTranslatorBuilder(C2h2C2h4C2h4C2h6),
};
